// src/components/Footer.js
import React from "react";
import "./Footer.css"; // Use Footer.css instead of App.css for specific styles

const Footer = () => {
  return (
    <footer className="footer themeBg text-zinc-300 z-100">
      <div className="footer-content">
        <p>
          © {new Date().getFullYear()} Omnicraft Studios. All rights reserved.
        </p>
        <ul className="footer-links ">
          <li>
            <a href="/about">About</a>
          </li>
          <li>
            <a
              className="col-span-1 text-center hover:text-zinc-300 h-full flex items-center justify-center"
              target="_blank"
              rel="noopener noreferrer"
              href="https://discord.gg/uwcRznrJsp"
            >
              <div className="lg:mx-[10%] mx-[5%]">Discord</div>
            </a>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
